import { inboxLocators } from '@locators/inbox';
import { Button } from '@servicetitan/anvil2';
import { TaskVoiceCardAction } from '../action-utils';
import styles from './TaskVoiceActions.module.css';
import ActionsRow from '../../TaskRow/ActionsRow/ActionsRow';
import { getTestIdProps } from '@lib/testUtils';
import useTaskActions from '@modules/TasksModule/hooks/useTaskActions';

interface TaskVoiceActionsProps {
  taskId: string;
  action?: TaskVoiceCardAction | null;
  isAnswering: boolean;
  isConnecting: boolean;
  isOffered: boolean;
  type: string;
}

export const TaskVoiceActions = ({
  taskId,
  action,
  isAnswering,
  isConnecting,
  isOffered,
  type,
}: TaskVoiceActionsProps) => {
  const { handleAccept, handleReject, handleComplete, handleResume } =
    useTaskActions(taskId);
  switch (action) {
    case TaskVoiceCardAction.activeCall:
      return (
        <ActionsRow
          isAnswering={isAnswering}
          callConnecting={isConnecting && isOffered}
          offered={isOffered}
          type={type}
          onAccept={handleAccept}
          onReject={handleReject}
        />
      );
    case TaskVoiceCardAction.endedCall:
      return (
        <div className={styles.buttonsContainer}>
          <Button
            onClick={handleComplete}
            size='small'
            {...getTestIdProps(inboxLocators.taskList.closeButton)}
          >
            Close
          </Button>
        </div>
      );
    case TaskVoiceCardAction.missedCall:
      return (
        <div className={styles.buttonsContainer}>
          <Button
            size='small'
            onClick={handleComplete}
            {...getTestIdProps(inboxLocators.taskList.dismissButton)}
          >
            Dismiss
          </Button>
        </div>
      );
    case TaskVoiceCardAction.heldCall:
      return (
        <div className={styles.buttonsContainer}>
          <Button
            size='small'
            onClick={handleResume}
            {...getTestIdProps(inboxLocators.taskList.resumeButton)}
          >
            Resume Call
          </Button>
        </div>
      );
    default:
      return null;
  }
};
